import Footer from "components/navigation/Footer";
import Navbar from "components/navigation/Navbar";
import Layout from "hocs/layouts/Layout";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import CategoriesHeader from "components/blog/CategoriesHeader";
import BlogList from "components/blog/BlogList";
import { fetchBlogList, fetchCategories } from "services/blogApi";

function Blog() {
	const [categories, setCategories] = useState([]);
	const [posts, setPosts] = useState([]);
	const [count, setCount] = useState(0);

	const loadCategories = async () => {
		try {
			const data = await fetchCategories();
			setCategories(data);
		} catch {
			setCategories([]);
		}
	};

	const loadBlogList = async (page = 1) => {
		try {
			const data = await fetchBlogList(page);
			setPosts(data.posts);
			setCount(data.count);
		} catch {
			setPosts([]);
			setCount(0);
		}
	};

	useEffect(() => {
		window.scrollTo(0, 0);
		loadCategories();
		loadBlogList();
	}, []);

	return (
		<Layout>
			<Helmet>
				<title>Fundación Arduvi | Blog</title>
				<meta
					name="description"
					content="Organización sin ánimo de lucro."
				/>
				<meta
					name="keywords"
					content="Organización sin ánimo de lucro."
				/>
				<meta name="robots" content="all" />
				<link rel="canonical" href="https://fundacionarduvi.org/" />
				<meta name="author" content="Fundación Arduvi" />
				<meta name="publisher" content="Fundación Arduvi" />

				{/* Social Media Tags */}
				<meta property="og:title" content="Fundación Arduvi | Inclusión con Amor" />
				<meta
					property="og:description"
					content="Organización sin ánimo de lucro."
				/>
				<meta property="og:url" content="https://fundacionarduvi.org/" />
				<meta
					property="og:image"
					content="https://bafybeicwrhxloesdlojn3bxyjqnxgsagtd4sl53a7t4cn4vfe2abmybzua.ipfs.w3s.link/lightbnuilbg.jpg"
				/>

				<meta name="twitter:title" content="Fundación Arduvi | Inclusión con Amor" />
				<meta
					name="twitter:description"
					content="Organización sin ánimo de lucro."
				/>
				<meta
					name="twitter:image"
					content="https://bafybeicwrhxloesdlojn3bxyjqnxgsagtd4sl53a7t4cn4vfe2abmybzua.ipfs.w3s.link/lightbnuilbg.jpg"
				/>
				<meta name="twitter:card" content="summary_large_image" />
			</Helmet>
			<header className="flex justify-center">
				<Navbar />
			</header>
			<div className="pt-24">
				<CategoriesHeader categories={categories && categories} />

				<div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
					{/* We've used 3xl here, but feel free to try other max-widths based on your needs */}
					<div className="mx-auto max-w-6xl my-10">
						{/* Content goes here */}
						{posts.length > 0 ? (
							<BlogList
							posts={posts}
							get_blog_list_page={loadBlogList}
							count={count}
						/>
						) :(
							<div className="flex justify-center">
								No hay publicaciones disponibles en este momento
							</div>
						)}
					</div>
				</div>
			</div>
			<Footer />
		</Layout>
	);
}

export default Blog;
